import { JsonLdResult } from 'bones/utils/jsonld/types';

export interface StardogVoiceboxDataRequest {
  connectionId: string;
  conversationId: string;
  messageId: string;
  context: Record<string, any>;
}

export interface StardogVoiceboxDataRequestJson {
  // eslint-disable-next-line camelcase
  connection_id: string;
  // eslint-disable-next-line camelcase
  conversation_id: string;
  // eslint-disable-next-line camelcase
  message_id: string;
  context: Record<string, any>;
}

export interface StardogVoiceboxDataResponse {
  actions: Array<{ label?: string; type: string; value: string }>;
  result: string;
  success: boolean;
}

export interface StardogVoiceboxAnalysisRequest
  extends StardogVoiceboxDataRequest {
  analysis: string;
  compute?: boolean;
}

export interface StardogVoiceboxAnalysisRequestJson
  extends StardogVoiceboxDataRequestJson {
  analysis: string;
  compute?: boolean;
}

export interface StardogVoiceboxChartRequest
  extends StardogVoiceboxDataRequest {
  chartStyle?: string;
}

export interface StardogVoiceboxChartRequestJson
  extends StardogVoiceboxDataRequestJson {
  // eslint-disable-next-line camelcase
  chart_style?: string;
}

export interface StardogVoiceboxDescriptionRequest {
  connectionId: string;
  databaseId: string;
  model: string;
}

export interface StardogVoiceboxDescriptionRequestJson {
  // eslint-disable-next-line camelcase
  connection_id: string;
  database: string;
  model: string;
}

export interface StardogVoiceboxDescriptionResponse {
  result: string;
}

export interface StardogVoiceboxDiagnosticsRequest {
  connectionId: string;
  databaseId: string;
  model?: string;
  checkAllSchemas?: boolean;
  checkQueries?: boolean;
}

export interface StardogVoiceboxDiagnosticsRequestJson {
  // eslint-disable-next-line camelcase
  connection_id: string;
  database: string;
  model?: string;
  // eslint-disable-next-line camelcase
  check_all_schemas?: boolean;
  // eslint-disable-next-line camelcase
  check_queries?: boolean;
}

export enum StardogVoiceboxDiagnosticsSeverity {
  INFO = 1,
  WARNING = 2,
  ERROR = 3,
}

export interface StardogVoiceboxDiagnosticsResult {
  text: string;
  severity: StardogVoiceboxDiagnosticsSeverity;
}

export interface StardogVoiceboxDiagnosticsResponse {
  results: StardogVoiceboxDiagnosticsResult[];
}

export interface StardogVoiceboxFeedbackRequest {
  messageId: string;
  comment?: string;
  score?: number;
}

export interface StardogVoiceboxFeedbackRequestJson {
  // eslint-disable-next-line camelcase
  message_id: string;
  comment?: string;
  score?: number;
}

export interface StardogVoiceboxGenerateStoredQueriesRequest {
  connectionId: string;
  databaseId: string;
  model: string;
}

export interface StardogVoiceboxGenerateStoredQueriesRequestJson {
  // eslint-disable-next-line camelcase
  connection_id: string;
  database: string;
  model: string;
}

export interface StardogVoiceboxMessageRequest {
  conversationId?: string;
  messageId?: string;
  connectionId: string;
  query: string;
  app: 'api' | 'cloud' | 'explorer' | 'studio' | 'designer';
  context: Record<string, any>;
}

// https://github.com/stardog-union/cloud-login/blob/main/src/api/voicebox/schemas.py#L223
export interface StardogVoiceboxMessageRequestJson {
  // eslint-disable-next-line camelcase
  conversation_id?: string;
  // eslint-disable-next-line camelcase
  message_id?: string;
  // eslint-disable-next-line camelcase
  connection_id: string;
  query: string;
  app: 'api' | 'cloud' | 'explorer' | 'studio' | 'designer';
  context: Record<string, any>;
}

export interface StardogVoiceboxMessageResponse {
  actions: Array<{ label?: string; type: string; value: string }>;
  conversationId: string;
  examples: string[];
  messageId: string;
  result: string;
  pending: boolean;
  success: boolean;
  type?: string;
}

// https://github.com/stardog-union/cloud-login/blob/main/src/api/voicebox/schemas.py#L287
export interface StardogVoiceboxMessageResponseJson {
  actions: Array<{ label?: string; type: string; value: string }>;
  // eslint-disable-next-line camelcase
  conversation_id: string;
  // eslint-disable-next-line camelcase
  followup_examples: string[];
  // eslint-disable-next-line camelcase
  message_id: string;
  result: string;
  pending: boolean;
  success: boolean;
  // eslint-disable-next-line camelcase
  message_type:
    | 'answer'
    | 'request_for_clarification'
    | 'disambiguation'
    | 'not_found'
    | 'llm_response'
    | 'failure'
    | 'chart_response'
    | 'query'
    | 'designer'
    | 'external_llm'
    | 'rag';
}

export interface StardogVoiceboxMappingSuggestionsRequest {
  connectionIdx: number;
  body: string;
}

export interface StardogVoiceboxMappingSuggestionsResponse {
  results: JsonLdResult[];
}
